import { post } from './apiClient';
import { DashboardEntityResponse } from './types';

interface DashboardEntityRequest {
  entityType: string;
  tenantIds: string[];
}

export const dashboardEntitiesService = {
  async fetchEntities(
    entityType: 'sit' | 'label' | 'policy',
    tenantIds: string[],
    pageNumber: number = 1
  ): Promise<DashboardEntityResponse> {
    const requestBody: DashboardEntityRequest = {
      entityType,
      tenantIds,
    };

    const { data } = await post<DashboardEntityResponse>(
      `Dashboard/entity?pageNumber=${pageNumber}`,
      requestBody
    );
    
    return data;
  },
};